import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IMutate, IQuery, RequestStatus } from "constants/crud";
import {
    GetMerchantSetupStepsCompleteAction,
    GetMerchantSetupStepsRequestAction,
    PutMerchantSetupStepsCompleteAction,
    PutMerchantSetupStepsRequestAction,
} from "actions/merchant/merchant-setup-steps";
import { ISetupSteps } from "constants/merchant";

export interface IState extends IQuery<ISetupSteps[]>, IMutate<ISetupSteps[]> {}

const initialState: IState = {
    queryError: undefined,
    queryStatus: RequestStatus.Idle,
    mutateStatus: RequestStatus.Idle,
    mutateError: undefined,
    result: [],
};

export const merchantSetupSteps = handleActions<IState, any>(
    {
        [MERCHANT.SETUP_STEPS.GET.REQUEST]: (state: IState, _action: GetMerchantSetupStepsRequestAction): IState => {
            return {
                ...state,
                ...initialState,
                queryStatus: RequestStatus.Active,
            };
        },
        [MERCHANT.SETUP_STEPS.GET.COMPLETE]: (state: IState, action: GetMerchantSetupStepsCompleteAction): IState => {
            return {
                ...state,
                queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                queryError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? [] : action.payload,
            };
        },
        [MERCHANT.SETUP_STEPS.PUT.REQUEST]: (state: IState, _action: PutMerchantSetupStepsRequestAction): IState => {
            return {
                ...state,
                mutateStatus: RequestStatus.Active,
                mutateError: undefined,
            };
        },
        [MERCHANT.SETUP_STEPS.PUT.COMPLETE]: (state: IState, action: PutMerchantSetupStepsCompleteAction): IState => {
            let newPayload: ISetupSteps[] = state.result;
            if (!!action?.payload && !(action.payload instanceof Error)) {
                if (newPayload.find((step) => step.name === action.payload.name)) {
                    newPayload = newPayload.map((step: ISetupSteps) => {
                        return step.name === action.payload.name ? (action.payload as ISetupSteps) : step;
                    });
                } else {
                    newPayload.push(action.payload);
                }
            }
            return {
                ...state,
                mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                mutateError: action.payload instanceof Error ? action.payload : undefined,
                result: action.payload instanceof Error ? [] : newPayload,
            };
        },
    } as any,
    initialState
);
